<template>
  <v-btn-toggle v-model="value" group :multiple="multiple" color="primary" :max="max">
    <v-btn
        v-for="n in total"
        :key="n-1"
        :value="str[n-1].cd"
        :min-width="minWidth"
        active-class="active"
        plain
    >
      {{ str[n - 1].cdNm }}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  props: {
    flag: Number, /* 한페이지에 여러개일 경우 구분값 */
    total: Number,
    minWidth: [String, Number],
    str: Array,
    max: Number,
    multiple: Boolean,
    answer: Array
  },
  data: () => ({
    // value:[]
  }),
  computed: {
    value: {
      get() {
        if (this.flag != undefined) {
          return Number(this.answer[this.flag]);
        } else {
          return this.answer;
        }

      },
      set(newValue) {
        if (this.flag != undefined) {
          return this.$emit('change', newValue, this.flag);
        } else {
          return this.$emit('selectBtn', newValue);
        }

      }
    }
  },

}
</script>
<style lang="scss" scoped>
::v-deep.v-btn-toggle {
  flex-wrap: wrap;
  justify-content: center;
  max-width: 330px;

  .v-btn {
    border: 1px solid #D9D9D9;
    border-radius: 6px !important;
    border-left-width: 1px !important;
    font-size: 16px;
    margin: 5px 8px;
  }

  .active {
    border-color: $color-main !important;
    box-shadow: 0px 2px 6px #00000029;
  }
}
</style>
